(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
/* Wargame Portal 3.0.15 — customer-controlled collection row.
   Native scroll + snap are the source of truth. No autoplay, slide cloning,
   opacity transitions or dependencies on the Hero slideshow controller. */
(() => {
  'use strict';
  const TAG = 'wgp-collection-carousel';
  if (customElements.get(TAG)) return;

  class CollectionCarousel extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this.initialized && this.dataset.layout === 'carousel') this.initialize();
      });
    }

    initialize() {
      this.track = this.querySelector('[data-collection-track]');
      if (!this.track) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.controls = this.querySelector('[data-collection-controls]');
      this.counter = this.querySelector('[data-collection-counter]');
      this.status = this.querySelector('[data-collection-status]');
      this.previous = this.querySelector('[data-collection-step="-1"]');
      this.next = this.querySelector('[data-collection-step="1"]');
      this.items = [...this.track.children].filter(item => item.matches('[data-collection-block]'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.targetPosition = null;
      this.shouldAnnounce = false;
      this.frame = null;
      this.settleTimer = null;
      const signal = this.abort.signal;
      const listen = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });

      listen(this.controls, 'click', event => {
        const button = event.target.closest('[data-collection-step]');
        if (!button || !this.controls.contains(button) || button.getAttribute('aria-disabled') === 'true') return;
        this.step(Number(button.dataset.collectionStep));
      });
      listen(this.track, 'scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        this.scheduleFinish();
      }, { passive: true });
      listen(this.track, 'scrollend', () => this.finish());
      // Do not hijack wheel/gesture events: vertical page scrolling stays native.
      const directInput = () => { this.targetPosition = null; this.shouldAnnounce = true; };
      listen(this.track, 'pointerdown', directInput, { passive: true });
      listen(this.track, 'wheel', directInput, { passive: true });
      listen(this.track, 'focusin', event => {
        const item = event.target.closest('[data-collection-block]');
        if (item && this.items.includes(item)) this.reveal(item);
      });
      listen(this.track, 'keydown', event => this.onKey(event));
      listen(window, 'resize', () => this.update());
      listen(this.motion, 'change', () => {
        if (this.motion.matches) this.moveTo(this.targetPosition ?? this.position, { immediate: true, announce: false });
      });
      listen(document, 'shopify:block:select', event => {
        if (!(event.target instanceof Element) || (!this.contains(event.target) && !event.target.contains(this))) return;
        const item = event.target.closest('[data-collection-block]') || this.items.find(node => node.dataset.collectionBlock === event.detail?.blockId);
        if (item && this.items.includes(item)) this.reveal(item);
      });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        if (this.items[0]) this.observer.observe(this.items[0]);
      }
      this.dataset.ready = 'true';
      this.update();
    }

    get rtl() { return getComputedStyle(this.track).direction === 'rtl'; }
    get maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    get position() { return Math.max(0, Math.min(this.maximum, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft)); }

    geometry() {
      const rect = this.track.getBoundingClientRect(), css = getComputedStyle(this.track);
      return {
        left: rect.left + this.track.clientLeft + (parseFloat(css.paddingLeft) || 0),
        right: rect.left + this.track.clientLeft + this.track.clientWidth - (parseFloat(css.paddingRight) || 0)
      };
    }

    itemPosition(item) {
      const rect = item.getBoundingClientRect(), view = this.geometry();
      return Math.max(0, Math.min(this.maximum, this.position + (this.rtl ? view.right - rect.right : rect.left - view.left)));
    }

    update() {
      if (!this.initialized || !this.isConnected) return;
      const overflow = this.maximum > 2 && this.items.length > 1;
      if (!overflow && this.controls?.contains(document.activeElement)) this.track.focus({ preventScroll: true });
      if (this.controls) this.controls.hidden = !overflow;
      if (overflow) this.track.setAttribute('tabindex', '0');
      else this.track.removeAttribute('tabindex');
      this.previous?.setAttribute('aria-disabled', String(!overflow || this.position <= 2));
      this.next?.setAttribute('aria-disabled', String(!overflow || this.position >= this.maximum - 2));
      const view = this.geometry();
      const visible = this.items.map((item, index) => {
        const rect = item.getBoundingClientRect();
        return Math.min(rect.right, view.right) - Math.max(rect.left, view.left) > 8 ? index : -1;
      }).filter(index => index >= 0);
      const first = visible.length ? visible[0] + 1 : 0;
      const last = visible.length ? visible[visible.length - 1] + 1 : 0;
      if (this.counter) this.counter.textContent = `${first === last ? first : `${first}\u2013${last}`} / ${this.items.length}`;
      this.visibleRange = { first, last };
    }

    moveTo(position, { immediate = false, announce = true } = {}) {
      const target = Math.max(0, Math.min(this.maximum, position));
      this.targetPosition = target;
      this.shouldAnnounce = this.shouldAnnounce || announce;
      this.track.scrollTo({ left: this.rtl ? -target : target, behavior: immediate || this.motion.matches ? 'auto' : 'smooth' });
      this.update();
      this.scheduleFinish();
    }

    step(direction) {
      const current = this.targetPosition ?? this.position;
      const positions = this.items.map(item => this.itemPosition(item));
      const next = direction > 0 ? positions.find(position => position > current + 2) : [...positions].reverse().find(position => position < current - 2);
      this.moveTo(next ?? (direction > 0 ? this.maximum : 0));
    }

    reveal(item) {
      const rect = item.getBoundingClientRect(), view = this.geometry();
      if (rect.left >= view.left - 2 && rect.right <= view.right + 2) return;
      this.moveTo(this.itemPosition(item), { immediate: true, announce: false });
    }

    onKey(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      if (!this.items.length || this.maximum <= 2) return;
      event.preventDefault();
      const direction = (event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1);
      const item = event.target.closest('[data-collection-block]');
      if (item && this.items.includes(item)) {
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : Math.max(0, Math.min(this.items.length - 1, this.items.indexOf(item) + direction));
        const next = this.items[index];
        next.querySelector('a[href]')?.focus({ preventScroll: true });
        this.reveal(next);
      } else if (event.key === 'Home' || event.key === 'End') {
        this.moveTo(event.key === 'Home' ? 0 : this.maximum);
      } else this.step(direction);
    }

    scheduleFinish() {
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.finish(), 180);
    }

    finish() {
      clearTimeout(this.settleTimer); this.settleTimer = null;
      if (!this.initialized || !this.isConnected) return;
      this.targetPosition = null;
      this.update();
      const { first, last } = this.visibleRange;
      if (this.shouldAnnounce && this.status && first) {
        this.status.textContent = first === last ? `Showing collection ${first} of ${this.items.length}.` : `Showing collections ${first} through ${last} of ${this.items.length}.`;
      }
      this.shouldAnnounce = false;
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.abort.abort();
      this.observer?.disconnect();
      clearTimeout(this.settleTimer);
      cancelAnimationFrame(this.frame);
      this.initialized = false;
      this.removeAttribute('data-ready');
    }
  }
  customElements.define(TAG, CollectionCarousel);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
/* No browser-local date parsing, interval decrement, persistent storage, or reset-on-refresh. */
(() => {
  'use strict';
  const TAG = 'wgp-countdown';
  if (customElements.get(TAG)) return;

  class WGPCountdown extends HTMLElement {
    static resolveDeadline(dateText, timeText, zone, ambiguous = 'earlier') {
      const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateText.trim());
      const time = /^(\d{2}):(\d{2})$/.exec(timeText.trim());
      if (!date || !time) throw new Error('Enter a date as YYYY-MM-DD and a 24-hour time as HH:MM (00:00 means midnight at the start of that date).');
      const [, y, m, d] = date.map(Number);
      const [, h, minute] = time.map(Number);
      const wall = Date.UTC(y, m - 1, d, h, minute);
      const check = new Date(wall);
      if (y < 2000 || y > 2099 || m < 1 || m > 12 || d < 1 || d > 31 || h > 23 || minute > 59 ||
          check.getUTCFullYear() !== y || check.getUTCMonth() !== m - 1 || check.getUTCDate() !== d) {
        throw new Error('Choose a valid calendar date between 2000 and 2099 and a time from 00:00 to 23:59.');
      }
      let formatter;
      try {
        formatter = new Intl.DateTimeFormat('en-GB-u-ca-gregory-nu-latn', {
          timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
      } catch (_) { throw new Error('The selected time zone is not supported by this browser.'); }
      const partsAt = stamp => {
        const parts = Object.fromEntries(formatter.formatToParts(new Date(stamp)).map(part => [part.type, part.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
      };
      // Sample both sides of a possible DST boundary. Only exact round trips
      // qualify; a nonexistent spring-forward time is rejected, not moved silently.
      const offsets = new Set();
      for (const hours of [-36, -12, 0, 12, 36]) {
        const sample = wall + hours * 3600000;
        offsets.add(partsAt(sample) - sample);
      }
      const candidates = [...offsets].map(offset => wall - offset).filter(stamp => partsAt(stamp) === wall).sort((a, b) => a - b);
      if (!candidates.length) throw new Error('This local time does not exist in the chosen time zone because the clock moves forward. Choose another time.');
      return ambiguous === 'later' ? candidates[candidates.length - 1] : candidates[0];
    }

    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.initialized) this.initialize(); });
    }

    initialize() {
      this.activeContent = this.querySelector('[data-countdown-active]');
      this.expiredContent = this.querySelector('[data-countdown-expired]');
      if (!this.activeContent || !this.expiredContent) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.timer = null;
      this.editor = this.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
      this.note = this.querySelector('[data-countdown-note]');
      this.status = this.querySelector('[data-countdown-status]');
      this.numbers = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-countdown-${unit}]`));
      this.showSeconds = this.dataset.seconds !== 'false';
      if (this.dataset.enabled !== 'true') {
        this.setState('disabled', 'Countdown is disabled. Enable this section to show it on the storefront.');
        return;
      }
      try {
        if (!this.dataset.endDate?.trim()) throw new Error('Choose a deadline in this Countdown section. Until then, this section is hidden on the storefront.');
        this.deadline = WGPCountdown.resolveDeadline(this.dataset.endDate, this.dataset.endTime || '00:00', this.dataset.timeZone || 'America/New_York', this.dataset.ambiguousTime);
        const deadlineDisplay = this.querySelector('[data-countdown-deadline]');
        if (deadlineDisplay) {
          deadlineDisplay.dateTime = new Date(this.deadline).toISOString();
          const options = { timeZone: this.dataset.timeZone || 'America/New_York', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' };
          try { deadlineDisplay.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', options).format(new Date(this.deadline)); }
          catch (_) { deadlineDisplay.textContent = new Intl.DateTimeFormat('en', options).format(new Date(this.deadline)); }
        }
      } catch (error) {
        this.setState('invalid', error.message || 'Check the countdown date, time, and time zone.');
        return;
      }
      document.addEventListener('visibilitychange', () => this.tick(), { signal: this.abort.signal });
      window.addEventListener('pageshow', () => this.tick(), { signal: this.abort.signal });
      window.addEventListener('pagehide', () => { clearTimeout(this.timer); this.timer = null; }, { signal: this.abort.signal });
      this.tick();
    }

    setState(state, message = '') {
      this.dataset.state = state;
      this.activeContent.hidden = state !== 'running';
      this.expiredContent.hidden = state !== 'ended';
      const hiddenAtEnd = state === 'ended' && this.dataset.after === 'hide';
      if (hiddenAtEnd && this.editor) message = 'This countdown has ended and is hidden on the storefront. Change its deadline or expiry behavior here.';
      this.hidden = !this.editor && (state === 'invalid' || state === 'disabled' || hiddenAtEnd);
      if (this.note) { this.note.textContent = message; this.note.hidden = !this.editor || !message; }
    }

    tick() {
      clearTimeout(this.timer); this.timer = null;
      if (!this.initialized || !this.isConnected || !Number.isFinite(this.deadline)) return;
      const remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        const wasRunning = this.dataset.state === 'running';
        this.setState('ended');
        if (wasRunning && this.status) this.status.textContent = this.expiredContent.querySelector('h2')?.textContent || 'The countdown has ended.';
        return;
      }
      this.setState('running');
      // Round UP the last visible unit, so a timer without seconds does not
      // display all zeroes for its last minute before the actual deadline.
      let seconds = this.showSeconds ? Math.ceil(remaining / 1000) : Math.ceil(remaining / 60000) * 60;
      const days = Math.floor(seconds / 86400); seconds %= 86400;
      const hours = Math.floor(seconds / 3600); seconds %= 3600;
      const minutes = Math.floor(seconds / 60); seconds %= 60;
      [days, hours, minutes, seconds].forEach((value, index) => {
        if (this.numbers[index]) this.numbers[index].textContent = String(value).padStart(2, '0');
      });
      this.style.setProperty('--wgp-count-day-digits', String(Math.max(2, String(days).length)));
      if (!document.hidden) {
        const resolution = this.showSeconds ? 1000 : 60000;
        this.timer = setTimeout(() => this.tick(), Math.max(50, (remaining % resolution || resolution) + 10));
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer); this.timer = null;
      this.abort?.abort();
      this.initialized = false;
      this.deadline = null;
    }
  }
  customElements.define(TAG, WGPCountdown);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const TAG = 'wgp-logo-showcase';
  if (customElements.get(TAG)) return;
  class WGPLogoShowcase extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'carousel') return;
      this.track = this.querySelector('[data-logo-track]');
      if (!this.track || this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-logo-step]');
        if (!button) return;
        const card = this.track.querySelector('[data-logo-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.logoStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('[data-logo-card]');
        if (card && this.contains(card)) card.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'auto' });
      });
    }
  }
  customElements.define(TAG, WGPLogoShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
/* Presentation utilities only. Balances stay server-rendered and read-only.
   No gift-card token/code is sent to a third party or written to browser storage. */
(() => {
  'use strict';
  const tag = 'wgp-gift-card-page';
  if (customElements.get(tag)) return;
  class GiftCardPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.start(); });
    }
    start() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const code = this.querySelector('[data-gift-code]');
      const copy = this.querySelector('[data-gift-copy]');
      if (copy && code?.value) {
        copy.hidden = false;
        copy.addEventListener('click', () => this.copyCode(code), { signal });
      }
      this.querySelectorAll('[data-gift-print]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => window.print(), { signal });
      });
      this.querySelectorAll('[data-gift-refresh]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => window.location.reload(), { signal });
      });
      window.addEventListener('pageshow', event => {
        // Browser Back can otherwise revive a stale balance snapshot from bfcache.
        if (event.persisted && this.dataset.issued === 'true' && this.dataset.editor !== 'true' && !window.Shopify?.designMode) window.location.reload();
      }, { signal });
    }
    async copyCode(field) {
      const signal = this.abort?.signal;
      const status = this.querySelector('[data-gift-copy-status]');
      const code = field.value.replace(/\s+/g, '');
      if (!code || !signal) return;
      let timeout;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await Promise.race([
          navigator.clipboard.writeText(code),
          new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Clipboard timeout')), 2500); })
        ]);
        if (!signal.aborted && this.isConnected && status) status.textContent = 'Gift card code copied.';
      } catch (_) {
        if (!signal.aborted && this.isConnected) {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, field.value.length);
          if (status) status.textContent = 'Code selected. Copy it using your device’s copy command.';
        }
      } finally { clearTimeout(timeout); }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define(tag, GiftCardPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
(() => {
  'use strict';

  const setup = root => {
    if (!root || root.dataset.passwordReady === 'true') return;
    root.dataset.passwordReady = 'true';

    const background = root.querySelector('[data-password-background]');
    const options = background ? [...background.querySelectorAll('template[data-password-background-option]')] : [];
    if (background && options.length) {
      let choice = 0;
      if (root.dataset.randomizeBackground !== 'false' && options.length > 1) {
        const key = `wgp-password-background:${root.dataset.passwordSectionId || 'password'}`;
        let previous = -1;
        try {
          const stored = sessionStorage.getItem(key);
          previous = stored === null ? -1 : Number(stored);
        } catch (_) {}
        const available = options.map((_, index) => index).filter(index => index !== previous);
        choice = available[Math.floor(Math.random() * available.length)];
        try { sessionStorage.setItem(key, String(choice)); } catch (_) {}
      }
      background.append(options[choice].content.cloneNode(true));
      const image = background.querySelector('img');
      const reveal = () => background.classList.add('is-loaded');
      if (!image || image.complete) reveal();
      else {
        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', reveal, { once: true });
      }
    }

    const dialog = root.querySelector('[data-password-dialog]');
    const opener = root.querySelector('[data-password-open]');
    const closer = root.querySelector('[data-password-close]');
    if (!dialog || !opener) return;

    const open = () => {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      requestAnimationFrame(() => dialog.querySelector('input[name="password"]')?.focus());
    };
    const close = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      opener.focus({ preventScroll: true });
    };

    opener.addEventListener('click', open);
    closer?.addEventListener('click', close);
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) close();
    });

    if (dialog.querySelector('[data-password-error]')) open();
  };

  document.querySelectorAll('.wgp-password-landing').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.matches?.('.wgp-password-landing') ? event.target : event.target.querySelector?.('.wgp-password-landing');
    setup(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bound = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-recommendations]').forEach(el => {
      if (bound.has(el) || el.querySelector('.product-grid') || !el.dataset.productId) return;
      bound.add(el);
      const load = async () => {
        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(root + 'recommendations/products', location.origin);
        for (const [key, value] of Object.entries({section_id: el.dataset.sectionId, product_id: el.dataset.productId, limit: el.dataset.limit, intent: el.dataset.intent})) url.searchParams.set(key, value);
        try { const r = await fetch(url); if (!r.ok) return; const doc = new DOMParser().parseFromString(await r.text(), 'text/html'); const next = doc.querySelector('[data-recommendations]'); if (next) el.innerHTML = next.innerHTML; } catch (_) {}
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { observer.disconnect(); load(); } }, { rootMargin: '300px' }); observer.observe(el);
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
/* Wargame Portal 3.0.13 — isolated Hero carousel, no dependencies.
   The legacy theme.js slideshow handler deliberately cannot match this markup.
   Seconds-per-slide is readable dwell time; transition time is additional. */
(() => {
  'use strict';
  const TAG = 'wgp-hero-slideshow';
  if (customElements.get(TAG)) return;

  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      // Also works when Shopify inserts a newly rendered section in the editor.
      queueMicrotask(() => { if (this.isConnected && !this.initialized) this.initialize(); });
    }

    initialize() {
      this.initialized = true;
      this.abort = new AbortController();
      this.slides = [...this.querySelectorAll('[data-wgp-slide]')];
      this.counter = this.querySelector('[data-wgp-counter]');
      this.rotation = this.querySelector('[data-wgp-rotation]');
      this.status = this.querySelector('[data-wgp-status]');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.dataset.active === 'true'));
      this.interval = Math.max(3000, Math.min(20000, Number(this.dataset.interval) || 6000));
      this.duration = Math.max(400, Math.min(1600, Number(this.dataset.transition) || 800));
      this.enabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileLayout = matchMedia('(max-width: 900px)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.resumeThroughHover = false;
      this.inView = !('IntersectionObserver' in window);
      this.editorSelection = new Set();
      this.animations = [];
      // Do not reuse an old generation after an editor remove/reinsert.
      this.revision = (this.revision || 0) + 1;
      this.transitionFinish = null;
      this.timer = null;
      this.loadingTimeout = null;
      this.loadCancel = null;
      this.busy = false;
      this.rotationPointerIntent = null;
      this.touchStart = null;
      this.reflectSlides();

      this.listen(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-wgp-rotation]')) {
          // A mouse/touch click focuses the button before its click event. Keep
          // the user's pre-focus intent rather than accidentally resuming.
          const wasPlaying = this.rotationPointerIntent;
          this.rotationPointerIntent = null;
          this.paused = wasPlaying === null ? !this.paused : wasPlaying;
          this.resumeThroughHover = !this.paused;
          this.syncPlayback();
        } else if (button.matches('[data-wgp-step]')) {
          this.paused = true;
          this.go(this.index + Number(button.dataset.wgpStep), { announce: true });
        }
      });
      this.listen(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
          this.hovered = true; this.syncPlayback();
        }
      });
      this.listen(this, 'pointerleave', () => {
        this.hovered = false; this.resumeThroughHover = false; this.syncPlayback();
      });
      this.listen(this, 'focusin', () => {
        // Do not restart after keyboard interaction until Play is requested.
        this.paused = true; this.resumeThroughHover = false; this.syncPlayback();
      });
      this.listen(this, 'pointerdown', event => {
        if (event.target.closest('[data-wgp-rotation]')) this.rotationPointerIntent = this.enabled && !this.paused;
        if (event.pointerType !== 'touch' || event.target.closest('a,button,input,select,textarea')) return;
        this.touchStart = { x: event.clientX, y: event.clientY, at: performance.now(), id: event.pointerId };
      });
      this.listen(this, 'pointercancel', () => { this.touchStart = null; this.rotationPointerIntent = null; });
      this.listen(this, 'pointerup', event => {
        const start = this.touchStart; this.touchStart = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5 && performance.now() - start.at < 900) {
          this.paused = true;
          this.go(this.index + (dx < 0 ? 1 : -1), { announce: true });
        }
      });
      this.listen(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input,select,textarea,[contenteditable="true"]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.paused = true;
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), { announce: true, moveFocus: true });
      });
      this.listen(document, 'visibilitychange', () => {
        // Background tabs can suspend animation clocks. Settle once rather than
        // returning to a paused fade with its copy still transparent.
        if (this.busy) this.cancelTransition();
        this.syncPlayback();
      });
      this.listen(window, 'pagehide', () => this.cancelTransition());
      this.listen(window, 'pageshow', () => {
        this.cancelTransition(); this.syncPlayback();
      });
      this.listen(this.mobileLayout, 'change', () => {
        if (this.busy) this.cancelTransition();
        this.syncPlayback();
      });
      this.listen(this.motion, 'change', () => {
        if (this.motion.matches) { this.paused = true; this.cancelTransition(); }
        this.syncPlayback();
      });
      // Selection must be handled at document level: section events target
      // Shopify's wrapper outside this custom element, not the element itself.
      this.listen(document, 'shopify:section:select', event => {
        if (event.target.contains(this)) { this.editorSelection.add('section'); this.cancelTransition(); this.syncPlayback(); }
      });
      this.listen(document, 'shopify:section:deselect', event => {
        if (event.target.contains(this)) { this.editorSelection.delete('section'); this.syncPlayback(); }
      });
      this.listen(document, 'shopify:block:select', event => {
        const slide = event.target.closest('[data-wgp-slide]');
        if (!slide || !this.contains(slide)) return;
        this.editorSelection.add('block');
        this.go(this.slides.indexOf(slide), { immediate: true });
        this.syncPlayback();
      });
      this.listen(document, 'shopify:block:deselect', event => {
        if (this.contains(event.target)) { this.editorSelection.delete('block'); this.syncPlayback(); }
      });
      this.listen(document, 'shopify:inspector:activate', () => { this.editorSelection.add('inspector'); this.cancelTransition(); this.syncPlayback(); });
      this.listen(document, 'shopify:inspector:deactivate', () => { this.editorSelection.delete('inspector'); this.syncPlayback(); });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .1);
          this.syncPlayback();
        }, { threshold: [0, .1] });
        this.observer.observe(this);
      }
      this.dataset.ready = 'true';
      this.primeNext();
      this.syncPlayback();
    }

    listen(target, type, listener) {
      target.addEventListener(type, listener, { signal: this.abort.signal });
    }

    get canRotate() {
      return this.enabled && !this.paused && !this.busy && !document.hidden && this.inView &&
        (!this.hovered || this.resumeThroughHover) && this.editorSelection.size === 0;
    }

    syncPlayback() {
      clearTimeout(this.timer); this.timer = null;
      if (!this.initialized || !this.isConnected) return;
      const requested = this.enabled && !this.paused;
      this.dataset.playback = !this.enabled ? 'disabled' : !requested ? 'paused' : this.canRotate ? 'playing' : 'suspended';
      if (this.rotation) {
        this.rotation.setAttribute('aria-label', requested ? (this.dataset.pauseLabel || 'Pause slideshow') : (this.dataset.playLabel || 'Play slideshow'));
        this.rotation.querySelector('[data-wgp-pause-icon]').hidden = !requested;
        this.rotation.querySelector('[data-wgp-play-icon]').hidden = requested;
      }
      if (this.canRotate) this.timer = setTimeout(() => {
        this.timer = null;
        if (this.canRotate) this.go(this.index + 1);
      }, this.interval);
    }

    reflectSlides() {
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.dataset.active = String(active);
        slide.removeAttribute('data-leaving');
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }

    primeNext() {
      if (this.slides.length < 2) return;
      const next = this.slides[(this.index + 1) % this.slides.length];
      next.querySelectorAll('img').forEach(image => {
        image.loading = 'eager';
        // Decode the next image during the current slide's reading time.
        try { if (image.decode) Promise.resolve(image.decode()).catch(() => {}); } catch (_) {}
      });
    }

    waitForImage(slide) {
      const image = slide.querySelector('img');
      if (!image) return Promise.resolve();
      image.loading = 'eager';
      return new Promise(resolve => {
        let settled = false;
        let timeout;
        const finish = () => {
          if (settled) return;
          settled = true;
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', finish);
          clearTimeout(timeout);
          if (this.loadCancel === finish) {
            this.loadingTimeout = null;
            this.loadCancel = null;
          }
          resolve();
        };
        const loaded = () => {
          if (settled) return;
          try {
            if (typeof image.decode === 'function') {
              Promise.resolve(image.decode()).then(finish, finish);
            } else finish();
          } catch (_) { finish(); }
        };
        this.loadCancel = finish;
        timeout = setTimeout(finish, 2500);
        this.loadingTimeout = timeout;
        if (image.complete) loaded();
        else {
          image.addEventListener('load', loaded, { once: true });
          image.addEventListener('error', finish, { once: true });
        }
      });
    }

    clearAnimations() {
      // Only cancel effects created by this controller, not merchant/app effects.
      const animations = this.animations.splice(0);
      animations.forEach(animation => {
        try { animation.cancel(); } catch (_) { /* Continue clearing other effects. */ }
      });
    }

    cancelTransition() {
      this.revision += 1;
      clearTimeout(this.timer); this.timer = null;
      this.loadCancel?.();
      this.transitionFinish?.();
      this.clearAnimations();
      this.busy = false;
      this.removeAttribute('data-transitioning');
      this.reflectSlides();
    }

    async go(requestedIndex, { immediate = false, announce = false, moveFocus = false } = {}) {
      if (!this.initialized || !this.slides.length) return;
      this.cancelTransition();
      const nextIndex = (requestedIndex % this.slides.length + this.slides.length) % this.slides.length;
      if (nextIndex === this.index) { this.syncPlayback(); return; }
      const outgoing = this.slides[this.index], incoming = this.slides[nextIndex];
      const revision = this.revision;
      this.busy = true;
      this.syncPlayback();
      if (!immediate) await this.waitForImage(incoming);
      if (!this.isConnected || revision !== this.revision) return;

      // Keyboard navigation from a slide link must not strand focus in inert
      // outgoing content. Button clicks keep focus on the clicked control.
      if ((moveFocus || outgoing.contains(document.activeElement)) && outgoing.contains(document.activeElement)) {
        this.querySelector('[data-wgp-step="1"]')?.focus({ preventScroll: true });
      }
      this.index = nextIndex;
      this.reflectSlides();
      if (announce && this.status) {
        const heading = incoming.querySelector('.wgp-hero-slide__heading')?.textContent?.trim() || '';
        this.status.textContent = `${this.index + 1} / ${this.slides.length}${heading ? ': ' + heading : ''}`;
      }
      if (immediate || this.motion.matches || typeof incoming.animate !== 'function') {
        this.busy = false; this.primeNext(); this.syncPlayback(); return;
      }

      outgoing.setAttribute('data-leaving', '');
      this.dataset.transitioning = 'true';
      try {
        await this.animateSlides(outgoing, incoming);
      } finally {
        // A stale async completion must never reset a newer selected slide.
        if (this.isConnected && revision === this.revision) {
          this.clearAnimations();
          this.busy = false;
          this.removeAttribute('data-transitioning');
          this.reflectSlides();
          this.primeNext();
          this.syncPlayback();
        }
      }
    }

    animateSlides(outgoing, incoming) {
      const animations = this.animations;
      return new Promise(resolve => {
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          if (this.transitionFinish === finish) this.transitionFinish = null;
          resolve();
        };
        // Completion is bounded even if an animation promise is interrupted,
        // suspended or never settles. Cancelling releases this same promise.
        const timeout = setTimeout(finish, this.duration + 250);
        this.transitionFinish = finish;
        const options = { duration: this.duration, easing: 'cubic-bezier(.2,.6,.2,1)', fill: 'both' };
        const animate = (node, keyframes, extra = {}) => {
          if (node) animations.push(node.animate(keyframes, { ...options, ...extra }));
        };
        try {
          const artIn = incoming.querySelector('[data-wgp-art]'), artOut = outgoing.querySelector('[data-wgp-art]');
          const visualIn = incoming.querySelector('[data-wgp-visual]'), visualOut = outgoing.querySelector('[data-wgp-visual]');
          const copyIn = incoming.querySelector('[data-wgp-copy]'), copyOut = outgoing.querySelector('[data-wgp-copy]');
          const drift = visualIn ? Math.abs(parseFloat(getComputedStyle(visualIn).left)) || 24 : 24;
          const copyDrift = Math.min(drift, 32);
          // Read the resting theme opacity before creating effects.
          const opacityIn = artIn ? getComputedStyle(artIn).opacity : '1';
          const opacityOut = artOut ? getComputedStyle(artOut).opacity : '1';
          // The fade window stays still; only the oversized image inside moves.
          animate(artIn, [{ opacity: 0 }, { opacity: opacityIn }]);
          animate(artOut, [{ opacity: opacityOut }, { opacity: 0 }]);
          animate(visualIn, [{ transform: `translateX(-${drift}px)` }, { transform: 'translateX(0)' }]);
          animate(visualOut, [{ transform: 'translateX(0)' }, { transform: `translateX(-${drift}px)` }]);
          animate(copyOut, [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: `translateX(-${copyDrift}px)` }], { duration: this.duration * .65 });
          animate(copyIn, [{ opacity: 0, transform: `translateX(-${copyDrift}px)` }, { opacity: 1, transform: 'translateX(0)' }], { duration: this.duration * .8, delay: this.duration * .2 });
          Promise.allSettled(animations.map(animation => animation.finished)).then(finish, finish);
        } catch (_) {
          // Unsupported/failed animation falls back to a visible instant change.
          finish();
        }
      });
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.cancelTransition();
      this.abort.abort();
      this.observer?.disconnect();
      this.removeAttribute('data-ready');
      this.initialized = false;
    }
  }
  customElements.define(TAG, HeroSlideshow);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonals"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const TAG = 'wgp-testimonials';
  if (customElements.get(TAG)) return;
  class WGPTestimonials extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'carousel' || this.ready) return;
      this.track = this.querySelector('[data-testimonial-track]');
      if (!this.track) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-testimonial-step]');
        if (!button) return;
        const card = this.track.querySelector('[data-testimonial-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.testimonialStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('[data-testimonial-card]');
        if (card && this.contains(card)) card.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'auto' });
      });
    }
  }
  customElements.define(TAG, WGPTestimonials);
})();

  } catch(e) { console.error(e); }
})();
})();
